import { css } from 'styled-components'
import { theme } from '../theme'

export const CheckStyle = css`
  appearance: none;

  &:after {
    content: "";
    position: relative;
    display: block;
    top: -25%;
    width: 20px;
    height: 20px;

    border: 1px solid #C4C4C4;
    border-radius: 50%;
    background: ${theme.colors.mainBg}
  }

  &:checked:after {
    background: ${theme.colors.iris};
    border: 3px solid ${theme.colors.mainBg};
    box-shadow: 0px 0px 0px 2px ${theme.colors.iris};
  }

  &:checked ~ span {
    font-weight: ${theme.font.bold};
  }
`
